import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaFacebookF } from "react-icons/fa";
import ChatWidget from "./ChatWidget";

import leadsnow from "../assets/leadsnow-cleaning-logo.png";
import cleanershout from "../assets/cleanershout.png";
import shopping from "../assets/cleaningsup.png";
import dusty from "../assets/dusty.png";
import vac from "../assets/vac.jpg";

import { useAppContext } from "../AppContext";
import plus from "../assets/ComCleanPlus.png";
import marketing from "../assets/marketing-kit.png";
import telemarekting from "../assets/telemarekting.png";
import posty from "../assets/posty.png";
import brochure from "../assets/brochure.png";
import image99 from "../assets/$99 value big.png";
import image49 from "../assets/$49 Com Cleaning.png";

const StripeFinalCodeCheck = React.lazy(() => import("./StripeFinalCodeCheck"));
import LanguageSwitcher from "./LanguageSwitcher";
import SecondForm from "./SecondForm";
import { EN_CLIENTS_PATH, EN_PROMOTE_PATH, ES_PROMOTE_PATH } from "../routes";

const CommercialCleaningPromote = () => {
  const { buyNow, setBuyNow, loadingHeader, selectedPrice, setSelectedPrice, leadsCount, setLeadsCount } = useAppContext();

  const plans = [
    { qty: 50, price: 39 },
    { qty: 200, price: 99 },
    { qty: 500, price: 199 },
  ];

  const faqItems = useMemo(
    () => [
      {
        key: "1",
        question: "What is the best way to promote a cleaning business?",
        answer:
          "The best approach combies clear targetting, direct outreach to decision-makers, and consistent follow-up over time."
      },
      {
        key: "2",
        question: "Is promoting a cleaning business",
        answer:
          "Promotion costs vary, but targeted outreach using leads often provides more control than traditional advertising",
      },
      {
        key: "3",
        question: "Can new cleaning businesses promote effectively?",
        answer:
          "Yes. New businesses often see success by focusing on a specific niche and using direct outreach rather than broad advertising"
      },
      {
        key: "4",
        question: "Do I need a website to promote my cleaning business?",
        answer:
          "A website helps with credibility, but promotion can begin through phone calls, emails, and direct contact",
      }
    ],
    []
  );

  const [openKeys, setOpenKeys] = useState(new Set());

  const { leftItems, rightItems } = useMemo(() => {
    const mid = Math.ceil(faqItems.length / 2);
    return { leftItems: faqItems.slice(0, mid), rightItems: faqItems.slice(mid) };
  }, [faqItems]);

  function IconPill({ open }) {
    return (
      <span
        className="inline-flex items-center justify-center shrink-0"
        style={{
          width: 26,
          height: 26,
          borderRadius: 999,
          // border: "2px solid #1465B7",
          color: "#1465B7",
          fontWeight: 800,
          lineHeight: 1,
          fontSize: 28,
        }}
        aria-hidden="true"
      >
        +
        {/* {open ? "−" : "+"} */}
      </span>
    );
  }

  function MinusBullet() {
    return (
      <span
        className="inline-flex items-center justify-center shrink-0"
        style={{
          width: 22,
          height: 22,
          borderRadius: 999,
          // background: "rgba(255,255,255,0.22)",
          color: "#fff",
          fontWeight: 900,
          lineHeight: 1,
          fontSize: 24,
        }}
        aria-hidden="true"
      >
        −
      </span>
    );
  }

  function FaqCard({ item, open, onToggle }) {
    const CARD_BG = "#E4F7F9";
    const BORDER = "rgba(38,169,74,0.40)";
    const GREEN = "#2FA84F";

    return (
      <div className="w-full">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          className="w-full text-left rounded-full border shadow-sm transition"
          style={{
            background: CARD_BG,
            borderColor: BORDER,
            padding: "12px 14px",
          }}
        >
          <div className="flex items-center gap-3">
            <IconPill open={open} />
            <h3 className="text-[#1465B7] text-lg font-medium leading-snug m-0">{item.question}</h3>
          </div>
        </button>

        <div
          className="overflow-hidden transition-[max-height,opacity,margin] duration-300 ease-in-out"
          style={{
            maxHeight: open ? 240 : 0,
            opacity: open ? 1 : 0,
            marginTop: open ? 10 : 0,
          }}
        >
          <div className="rounded-2xl shadow-sm" style={{ background: GREEN, padding: "14px 16px" }}>
            <div className="flex gap-3 items-start">
              <MinusBullet />
              <p className="text-white text-lg leading-relaxed">{item.answer}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const pageUrl = "https://www.commercialcleaningleadsforyou.com/how%20to%20promote%20your%20commercial%20cleaning%20business";

  return (
    <div>
      <Helmet>
        <title>How to Get Clients for Your Commercial Cleaning Business (Step-by-Step)</title>
        <meta
          name="description"
          content="Learn how commercial cleaning companies consistently get clients using a proven step-by-step process and targeted commercial cleaning leads."
        />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" hrefLang="en" href={pageUrl} />
        <link rel="alternate" hrefLang="es" href={`https://www.commercialcleaningleadsforyou.com${ES_PROMOTE_PATH}`} />
        <link rel="alternate" hrefLang="x-default" href="https://www.commercialcleaningleadsforyou.com/" />

        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.commercialcleaningleadsforyou.com/#organization",
      "name": "Leads Now Commercial Cleaning",
      "url": "https://www.commercialcleaningleadsforyou.com/",
      "description": "Leads Now Commercial Cleaning provides commercial cleaning leads and outreach-ready contact data to help cleaning businesses consistently acquire new clients.",
      "sameAs": [],
      "email": "leadsnowproducts@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "12020 Shamrock Plaza #200",
        "addressLocality": "Omaha",
        "addressRegion": "NE",
        "postalCode": "68154",
        "addressCountry": "US"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "email": "leadsnowproducts@gmail.com",
        "availableLanguage": ["English"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://www.commercialcleaningleadsforyou.com/#website",
      "url": "https://www.commercialcleaningleadsforyou.com/",
      "name": "Leads Now Commercial Cleaning",
      "publisher": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#organization"
      },
      "inLanguage": "en-US"
    },
    {
      "@type": "WebPage",
      "@id": "${pageUrl}/#webpage",
      "url": "${pageUrl}",
      "name": "How to Get Clients for Your Commercial Cleaning Business",
      "description": "A step-by-step guide showing how commercial cleaning businesses promote and win clients using targeted outreach and verified leads.",
      "inLanguage": "en-US",
      "isPartOf": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#website"
      },
      "publisher": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#organization"
      },
      "mainEntity": [
        {
          "@id": "${pageUrl}/#howto"
        },
        {
          "@id": "${pageUrl}/#faq"
        },
        {
          "@id": "${pageUrl}/#service"
        }
      ]
    },

    {
      "@type": "HowTo",
      "@id": "${pageUrl}/#howto",
      "name": "How to Get Clients for Your Commercial Cleaning Business",
      "description": "A repeatable, step-by-step approach used by successful commercial cleaning companies to consistently win new clients.",
      "inLanguage": "en-US",
      "totalTime": "P30D",
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "Commercial cleaning leads"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "Define the type of cleaning clients you want",
          "text": "Clarify who you’re trying to reach. Successful cleaning companies focus on specific client types, such as office buildings, medical or dental offices, schools and childcare facilities, warehouses and industrial buildings, retail stores and shopping centers, and property managers and multi-tenant facilities."
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "Identify the decision-makers who control cleaning contracts",
          "text": "Cleaning contracts are typically decided by business owners, office managers, facility managers, and property managers. To get clients, you must reach people who can say yes."
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "Use commercial cleaning leads to reach the right businesses",
          "text": "Commercial cleaning leads are verified business contacts that match your target market and allow you to reach decision-makers directly — without waiting for referrals or online inquiries."
        },
        {
          "@type": "HowToStep",
          "position": 4,
          "name": "Target by location, industry, and building type",
          "text": "Use targeted outreach by segmenting leads with city/county/ZIP code, type of business, building size, and ownership status. Better targeting improves response rates."
        },
        {
          "@type": "HowToStep",
          "position": 5,
          "name": "Choose an outreach method and be consistent",
          "text": "Consistency matters more than perfection. Common outreach methods include phone outreach, email introductions, direct mail, and multi-touch follow-ups."
        },
        {
          "@type": "HowToStep",
          "position": 6,
          "name": "Track responses and refine your approach",
          "text": "Measure what works by tracking who responds, which industries convert best, and which messages get callbacks. Over time, your process becomes more efficient and predictable."
        }
      ]
    },

    {
      "@type": "FAQPage",
      "@id": "${pageUrl}/#faq",
      "url": "${pageUrl}",
      "name": "Frequently Asked Questions",
      "inLanguage": "en-US",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How can I get clients for my cleaning business if I’m just starting out?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The fastest method is consistent outreach to verified decision-makers at businesses that already outsource cleaning, typically using commercial cleaning leads combined with phone calls, emails, or direct mail."
          }
        },
        {
          "@type": "Question",
          "name": "How often should I follow up with potential cleaning clients?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most cleaning companies follow up 5–7 times over 30–45 days. Repeated, professional follow-up increases response chances without being intrusive."
          }
        },
        {
          "@type": "Question",
          "name": "What is the fastest way to get commercial cleaning clients?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The fastest method is consistent outreach to verified decision-makers at businesses that already outsource cleaning, typically using commercial cleaning leads and follow-ups."
          }
        },
        {
          "@type": "Question",
          "name": "What types of businesses hire commercial cleaning services most often?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Office buildings, medical/dental practices, schools, retail stores, warehouses, and property management companies typically have recurring cleaning needs."
          }
        },
        {
          "@type": "Question",
          "name": "Is cold calling still effective for cleaning businesses?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. When done professionally and with targeted leads, cold calling remains one of the most effective ways to introduce cleaning services and schedule walkthroughs."
          }
        }
      ]
    },

    {
      "@type": "Service",
      "@id": "${pageUrl}/#service",
      "name": "Commercial Cleaning Leads (500 Leads Instant Download)",
      "description": "Verified business contact leads that match your target market and help you reach commercial cleaning decision-makers. Pick your ZIP code, download and segment 500 leads, launch outreach, and track results.",
      "areaServed": [
        { "@type": "Country", "name": "United States" }
      ],
      "provider": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#organization"
      },
      "offers": {
        "@type": "Offer",
        "url": "${pageUrl}",
        "priceCurrency": "USD",
        "price": "199.00",
        "availability": "https://schema.org/InStock",
        "name": "Get Started For Just $199",
        "description": "Only $199 for 500 commercial cleaning leads. Instant download."
      }
    }
  ]
}
`}
        </script>
        <title>How to Get Clients for Your Commercial Cleaning Business</title>
        <meta
          name="description"
          content="Learn how commercial cleaning companies consistently get clients using a proven step-
by-step process and targeted commercial cleaning leads."
        />
      </Helmet>

      <header className="relative bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300 overflow-hidden">
        <div className="px-4 pt-4 md:px-0 md:pt-0 md:absolute md:top-6 md:right-6 z-30">
          <div className="flex items-center gap-4">
            <LanguageSwitcher />

            <a
              href="https://www.facebook.com/profile.php?id=61582707424269"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-block"
              aria-label="Facebook"
            >
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#1877F2] shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-110 active:scale-95">
                <FaFacebookF className="text-white" size={24} />
              </div>
            </a>
          </div>
        </div>

        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce"></div>
          <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce"></div>
          <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
          <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce"></div>
          <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 pb-8 pt-2 md:pt-8">
          <div className={`max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 ${(buyNow === 'payment' || buyNow === 'download') ? 'items-start' : 'items-center'}`}>
            <div className="text-center lg:text-left min-w-0">
              <div className="mb-8 flex justify-center lg:justify-start">
                <img
                  src={leadsnow}
                  alt="Leads Now"
                  className="w-[280px] lg:w-[220px]"
                />
              </div>

              <h1 className="text-4xl font-semibold text-[#1465B7] leading-tight">
                How To Promote Your Cleaning Business
              </h1>

              {/* {!(buyNow === 'payment' || buyNow === 'download') && ( */}
                <>
                  <h2 className="mt-5 text-xl md:text-2xl font-medium mb-4 max-w-xl text-[#1465B7]">
                    If you're searching for how to promote your cleaning business, the most effective approach isn't a single marketing tactic - it's a repeatable promotion system that puts your services in front of the right businesses at the right time.
                  </h2>

                  <h3 className="mt-4 text-lg font-medium text-[#26A94A] mb-8 max-w-xl mx-auto lg:mx-0">
                    Below is a proven, step-by-step approach used by successful commercial cleaning companies to consistently win new clients.
                  </h3>

                  <div className="mt-7">
                    <button
                      className="rounded-3xl border-2 border-[#1E7A4C] bg-[#FFE96A] px-6 py-3 text-sm font-extrabold text-[#1465B7] shadow-sm hover:brightness-95"
                      style={{ color: "#1465B7" }}
                      onClick={() => {
                        document.getElementById('service').scrollIntoView({ behavior: 'smooth' });
                      }}
                    >
                      Get Started For Just $199
                    </button>
                  </div>
                </>
               {/* )} */}
            </div>

            <div className="flex justify-center lg:justify-end min-w-0">
              <div className={`flex-shrink-0 md:min-w-md w-full ${(buyNow === 'payment' || buyNow === 'download') ? 'lg:max-w-[28rem] lg:w-full' : 'lg:min-w-md lg:w-80'} items-center`}>
                {buyNow === 'home' && (
                  <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#26A94A]">
                    <div className="flex">
                      <button className="flex-1 bg-[#26A94A] text-white p-4 font-semibold  rounded-b-2xl">
                        <span className="text-white text-lg">Commercial Cleaning Leads For You</span>
                      </button>
                    </div>

                    <div className="px-5 py-4">
                      <p className="text-xl font-bold text-[#1465B7] mb-3 text-center font-semibold">
                        Get Your List Now
                      </p>
                      <p className="text-md text-gray-600 mb-4">
                        Send me {leadsCount} commercial cleaning business around my
                        <br /> zipcode{" "}
                      </p>

                      {/* 50 / 200 / 500 Leads row */}
                      <div className="flex justify-center mb-6">
                        <div
                          className="
                            w-full
                            bg-[#BFEAF2]
                            border-[3px] border-[#26A94A]
                            rounded-xl
                            overflow-hidden
                            grid grid-cols-3
                          "
                        >
                          {plans.map((p, idx) => (
                            <button
                              key={p.qty}
                              type="button"
                              onClick={() => {
                                setLeadsCount(p.qty);
                                setSelectedPrice(p.price * 100);
                              }}
                              className={`
                                py-2
                                flex flex-col items-center justify-center
                                transition
                                cursor-pointer
                                ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
                                ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
                              `}
                            >
                              <span
                                className="
                                  text-lg
                                  font-extrabold leading-none
                                  text-[#EAFB55]
                                  drop-shadow-[1.5px_1.5px_0px_#2E7D32]
                                "
                              >
                                {p.qty}
                              </span>
                              <span className="text-sm font-extrabold leading-none text-[#1465B7]">
                                Leads
                              </span>
                              <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">
                                ${p.price}
                              </span>
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="mt-8">
                          <button
                            className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-black font-bold py-4 rounded-full transition-colors border-3 border-[#26A94A] cursor-pointer"
                            style={{ color: "#1465B7", fontSize: "28px" }}
                            onClick={() => setBuyNow('payment')}
                          >
                            Buy Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(buyNow === 'payment' || buyNow === 'download') && (
                  <React.Suspense fallback={<div>Loading...</div>}>
                    <StripeFinalCodeCheck />
                  </React.Suspense>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="w-full py-16" id="howto">
        <div className="mx-auto max-w-5xl px-4">

          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-extrabold text-[#26A94A] mb-4">
                Step 1: Decide Who You Want to Promote Your Cleaning Business Services To
              </h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Promotion works best when it's focused
              </h3>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Before marketing your cleaning business, clearly define the types of clients you eant to reach, such as
              </p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Office buildings</li>
                <li>Medical or dental offices</li>
                <li>Schools and childcare facilities</li>
                <li>Warehouses and industrial buildings</li>
                <li>Retail stores and shopping centers</li>
                <li>Property managers and multi-tenant facilities</li>
              </ul>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Clear targetting helps your message reach people who actually hire cleaning services.
              </p>
            </div>

            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">
                Step 2: Reach the People Who Make Cleaning Decisions
              </h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Promoting a cleaning business isn't about visibility alone - it's about contacting the right people.
              </h3>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Cleaning companies commonly reach prospects through:
              </p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Business owners</li>
                <li>Office managers</li>
                <li>Facility managers</li>
                <li>Property managers</li>
              </ul>
              <p className="mt-4 text-base text-[#1465B7]">
                Effective promotion focuses on these decision-makers rather than genral contacts.
              </p>
            </div>

            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">
                Step 3: Use Direct Outreach instead of Waiting for Referrals
              </h2>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Many Cleaning companies rely heavily on:
              </p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Referrals</li>
                <li>Online ads</li>
                <li>Social media</li>
              </ul>
              <p className="mt-4 text-base text-[#1465B7]">
                While these methods can help, they are unpredictable
              </p>
              <p className="mt-4 text-base text-[#1465B7]">
                Direct outreach allows you to actively promote your cleaning business to qualifed prospects instead of waiting to be found
              </p>
            </div>

            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">
                Step 4: Promote Smarter with Commercial Cleaning Leads
              </h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                One of the most efficient ways to promote cleaning business is by using commercial cleaning leads
              </h3>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Cleaning leads provide verified business contact information, allowing you to:
              </p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Introduce your services directly</li>
                <li>Reach decision-makers without guesswork</li>
                <li>Control how quickly you grow</li>
              </ul>
              <p className="mt-4 text-base text-[#1465B7]">
                This removes uncertainly from promotion
              </p>
            </div>

            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">
                Step 5: Use Multiple Promotion Channels
              </h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Successful cleaning businesses don't rely on just one channel
              </h3>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Common promotion methods include:
              </p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Phone outreach</li>
                <li>Email introductions</li>
                <li>Direct mail</li>
                <li>Multi-touch follow-ups</li>
              </ul>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Consistency across channels builds recognition and trust over time.
              </p>
            </div>

            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">
                Step 6: Measure Results and Improve Your Promotion Strategy
              </h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Effective promotion improves when it's measured.
              </h3>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Track:
              </p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Which industries respond best</li>
                <li>Which messages generate callbacks</li>
                <li>Which channels start conversations</li>
              </ul>
              <p className="text-base text-[#1465B7] leading-relaxed">
                Over time, your promotion becomes more efficient and predictable.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full pb-16">
        <div className="mx-auto max-w-5xl px-4">
          <div className="rounded-3xl border-2 border-[#26A94A] bg-[#E0F7FA] px-6 py-10 shadow-lg">
            <div className="flex flex-col md:flex-row items-center justify-between gap-10">
              <div className="hidden md:block shrink-0">
                <img src={vac} alt="Cleaner" className="h-[160px] w-auto" width={160} height={160} loading="lazy" />
              </div>

              <div className="flex-1 text-center">
                <h2 className="text-2xl font-bold text-[#26A94A] mb-6">
                  Why This Promotion System Works for Cleaning Businesses
                </h2>

                <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                  This approach works because it:
                </h3>

                <ul className="inline-block list-disc space-y-3 pl-8 text-left text-lg text-[#1465B7]">
                  <li>Focuses on qualified prospects</li>
                  <li>Reaches decision-makers directly</li>
                  <li>Creates a steady pipeline of opportunities</li>
                  <li>Reduces reliance on referrals alone</li>
                  <li>Scales as your cleaning business grows</li>
                </ul>

                <p className="mt-8 text-lg font-medium text-[#26A94A]">
                  It’s repeatable, measurable, and built for growth.
                </p>

                <div className="mt-8">
                  <button
                    type="button"
                    className="rounded-full border-2 border-[#1E7A4C] bg-[#FFE96A] px-12 py-4 text-lg font-extrabold text-[#1465B7] shadow-md hover:brightness-105 transition"
                    onClick={() => {
                      document.getElementById('service').scrollIntoView({ behavior: 'smooth' });
                    }}
                    style={{ color: "#1465B7" }}
                  >
                    Get Started For Just $199
                  </button>
                </div>
              </div>

              <div className="hidden md:block shrink-0">
                <img src={dusty} alt="Cleaner" className="h-[160px] w-auto" width={160} height={160} loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>





      <section className="py-16 bg-[#DBE4E5]">
        <div className="relative z-10 container mx-auto px-4 py-8">
          {/* <div className="flex flex-col lg:flex-row justify-center gap-8"> */}
          <div className="block lg:flex max-w-5xl mx-auto">

            {/* Left Content */}
            <div className="flex-1  max-w-xl text-center lg:text-left">
              <div className="mb-3 max-w-lg">
                <p className="text-[#26A94A] font-bold text-3xl ">
                  {" "}
                  Get Started:{" "}
                  <span className="text-[#1465B7]">
                    Pick your zip code, <br /> we do the rest!
                  </span>
                </p>
                {/* </div> */}
                <div>
                  <ul className="list-disc ml-5 text-lg text-gray-700">
                    <li>
                      Download and segment inside the 500 commercial <br />
                      cleaning leads based on your marketing goals.
                    </li>

                    <li className="my-2">
                      Launch your outreach through email, ads, calls, or <br />{" "}
                      direct mail.
                    </li>

                    <li>
                      Track your results and fine-tune for even better <br />{" "}
                      outcomes.
                    </li>
                  </ul>
                </div>
                <div className="mt-3">
                  <p className="text-gray-700 text-lg leading-normal gap-y-2">
                    You don’t need an agency. You don’t need a big <br />{" "}
                    marketing team. Just the right list and a smart plan. It’s{" "}
                    <br /> that simple: You get the list. You do the outreach.
                    <br />
                    And you keep 100% of the profits.
                  </p>
                </div>

                <div className="font-semibold text-[#26A94A] text-lg">
                  <p>
                    Only ${selectedPrice / 100} for {leadsCount} leads.
                    <br />
                    Commercial Cleaning Leads For You
                  </p>
                </div>
              </div>

            </div>

            {/* Right Form */}
            {buyNow === 'home' &&
              <div className="flex-shrink-0 md:min-w-md lg:min-w-md w-full lg:w-80">
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#26A94A]">
                  <div className="flex">
                    <button className="flex-1 bg-[#26A94A] text-white p-4 font-semibold  rounded-b-2xl">
                      <span className="text-white text-lg">Commercial Cleaning Leads For You</span>
                    </button>
                  </div>

                  <div className="px-5 py-4">
                    <p className="text-xl font-bold text-[#1465B7] mb-3 text-center font-semibold">
                      Get Your List Now
                    </p>
                    <p className="text-md text-gray-600 mb-4">
                      Send me {leadsCount} commercial cleaning business around my
                      <br /> zipcode{" "}
                    </p>

                    {/* 50 / 200 / 500 Leads row */}
                    <div className="flex justify-center mb-6">
                      <div
                        className="
                          w-full
                          bg-[#BFEAF2]
                          border-[3px] border-[#26A94A]
                          rounded-xl
                          overflow-hidden
                          grid grid-cols-3
                        "
                      >
                        {plans.map((p, idx) => (
                          <button
                            key={p.qty}
                            type="button"
                            onClick={() => {
                              setLeadsCount(p.qty);
                              setSelectedPrice(p.price * 100);
                            }}
                            className={`
                              py-2
                              flex flex-col items-center justify-center
                              transition
                              cursor-pointer
                              ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
                              ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
                            `}
                          >
                            <span
                              className="
                                text-lg
                                font-extrabold leading-none
                                text-[#EAFB55]
                                drop-shadow-[1.5px_1.5px_0px_#2E7D32]
                              "
                            >
                              {p.qty}
                            </span>
                            <span className="text-sm font-extrabold leading-none text-[#1465B7]">
                              Leads
                            </span>
                            <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">
                              ${p.price}
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div className="mt-8">
                        <button
                          className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-black font-bold py-4 rounded-full transition-colors border-3 border-[#26A94A] cursor-pointer"
                          style={{ color: "#1465B7", fontSize: "28px" }}
                          onClick={() => {
                            setBuyNow('payment');
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Buy Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {loadingHeader && <div className="flex min-h-screen">
              <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
            </div>}
            {buyNow === "download" && (
              <React.Suspense fallback={<div>Loading...</div>}>
                <StripeFinalCodeCheck />
              </React.Suspense>
            )}
            {buyNow === "payment" && (
              <button
                type="button"
                className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-[#1465B7] font-bold py-4 rounded-full border-3 border-[#26A94A] cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Complete payment above ↑
              </button>
            )}

          </div>
        </div>
        <div className="container mx-auto max-w-5xl px-4 md:px-0">
          <div className="text-center mb-12">
            {/* <div className="flex mx-auto items-center gap-5 justify-between"> */}
            {/* <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
   
                <img src={plus} width={200} height={125} />
               <div className="mt-4">
                 <p className="text-3xl text-[#1465B7] font-bold">
                   Get These <span className="text-[#26A94A]">Extras</span> With
                   Every Order
                 </p>
               </div>
               <img src={plus} width={200} height={125} />
             </div>
    */}
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
              <img src={plus} width={200} height={125} />

              <div className="mt-4">
                <p className="text-3xl text-[#1465B7] font-bold">
                  Get These <span className="text-[#26A94A]">Extras</span> With Every Order
                </p>
              </div>

              <img src={plus} width={200} height={125} className="hidden sm:block" />
            </div>
            <div className="container mx-auto max-w-5xl px-4 md:px-0 mt-8">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 max-w-4xl justify-center mx-auto">
                {/* <div>
                 <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                   <img src={marketing} width={130}/>
                 </div>
                 <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                   The Commercial <br/> Cleaning Marketing <br/>Made Easy <br/> Marketing Kit !
                 </p>
               </div> */}
                <div>
                  <div className="relative flex justify-center items-center">
                    {/* First Image */}
                    <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                      <img src={image99} width={130} />
                    </div>
                    <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                      <img src={marketing} width={130} />
                    </div>

                    {/* Second Image - overlapping the first */}
                  </div>

                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center mt-4 ml-4">
                    The Commercial <br />
                    Cleaning Marketing <br />
                    Made Easy <br />
                    Marketing Kit!
                  </p>
                </div>

                <div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                    <img src={telemarekting} width={130} />
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                    Bonus Voice Mail <br /> Script
                  </p>
                </div>
                <div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                    <img src={posty} width={130} />
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                    Bonus Postcard <br /> Templates
                  </p>
                </div>
                <div>
                  {/* <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                     <img src={brochure} width={130} />
                   </div> */}
                  <div className="relative flex justify-center items-center">
                    {/* First Image */}
                    <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                      <img src={image49} width={130} />
                    </div>
                    <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                      <img src={brochure} width={130} />
                    </div>

                    {/* Second Image - overlapping the first */}
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center ml-6">
                    Bonus Brouchure <br /> Templates
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Related guides - other two pages only (this page = Promote) */}
      <div className="bg-[#e8f4f6] py-6 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-[#1465B7] font-semibold text-sm uppercase tracking-wide mb-3 text-center">
            Related Guides
          </p>
          <p className="related-guides-links flex flex-wrap justify-center gap-x-4 gap-y-2 items-center text-center">
            <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">Home</Link>
            <Link to={EN_CLIENTS_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">How to Get Clients for Your Commercial Cleaning Business</Link>
          </p>
        </div>
      </div>

      <footer className="bg-[#BFEAF2] py-20 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <p className="text-xl font-medium text-[#26A94A] mb-4">
            For any issues contact support at:{" "}
            <a href="mailto:leadsnowproducts@gmail.com" className="underline hover:text-[#1465B7] transition">leadsnowproducts@gmail.com</a>
          </p>
          <p className="text-lg text-[#26A94A]">
            12020 Shamrock Plaza #200 Omaha, NE 68154
          </p>
        </div>
      </footer>

      <ChatWidget />
    </div>
  );
};

export default CommercialCleaningPromote;
